
export const authFeatureKey = "auth";

export const nftFeatureKey = "nftData";
